// extracted by mini-css-extract-plugin
module.exports = {"activeLink":"SidebarLink__activeLink--Pu","link":"SidebarLink__link--vB","content":"SidebarLink__content--KC","tail":"SidebarLink__tail--cB"};